const danasAdditionalRootCategories = ['sport', 'vrijeme', 'videovijesti', 'zivot']

const isDanas = process.env.NEXT_PUBLIC_APP_NAME_RTL === 'danas.hr'

// eslint-disable-next-line import/no-commonjs
module.exports = {
    isDanas,
    danasAdditionalRootCategories
}
